export default "__VITE_ASSET__CrtXyCMk__"